import React, { Component ,Fragment } from "react";
import PropTypes from "prop-types";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import http from "../../../../services/HttpService";
import {Link} from "react-router-dom";
import Route from "../../../../Routes";
import Loading from "../../../includes/Loading";

import Avatar from "../../../../../assets/img/dashboard/users/avatar-1.png";
import LayoutDashboard from "../../../../views/layout/Dashboard";
import {layout} from "../../../../../ts-helpers/decorators";
import Moment from 'react-moment';
import 'moment-timezone';

import Confirm from 'react-confirm-bootstrap';

import {
    Container,
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button
} from 'reactstrap';

@layout(LayoutDashboard)
@(connect((state) => {
    return { };
}) as any)

export default class AllUsers extends Component<any> {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    state = {
        users:[],
        loading: true,
    };

    constructor(props: Map<any, any>) {
        super(props);
    }

    componentDidMount() {
        this.getData();
        this.props.onRef(this);
    }

    @autobind
    getData(){
        http.get('/users/all')
            .then(response => response.json())
            .then((data) => {
                this.setState({
                    users:data,
                    loading:false,
                });
            });
    }

    @autobind
    onConfirm(e,userId) {
        http.get(`/users/delete/${userId}`)
            .then(response => response.json())
            .then((data) => {
                if(data.status == "success"){
                    this.getData()
                }
            });
    }

    render() {
        const { users, loading }=this.state;


        return(
            <Container fluid>
                <Row>
                    <Col xs={12}>
                        <h4 className="header-title m-t-0 m-b-20">Users!</h4>
                    </Col>
                </Row>
                {
                    loading ? <Container><Row><Col className="text-center"><Loading isLoading={loading} icon="loadDashboardInfo"/></Col></Row></Container> :
                        <Fragment>
                            <Row>
                                <Col className="col-xs-10 col-xs-offset-1 col-sm-10 col-sm-offset-1">
                                    <table className="table">
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Firstname</th>
                                            <th>Lastname</th>
                                            <th>Email</th>
                                            <th>Created</th>
                                            <th>Delete</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            users.map((user, i) => (
                                                <tr key={i}>
                                                    <td>{i+1}</td>
                                                    <td>{user.name}</td>
                                                    <td>{user.surname}</td>
                                                    <td>{user.email}</td>
                                                    <td>
                                                        <Moment format="YYYY/MM/DD">
                                                            {user.createdAt}
                                                        </Moment>
                                                    </td>
                                                    <td>
                                                        {
                                                            user.role != 'admin' &&
                                                                <Confirm
                                                                    onConfirm={(e)=>{this.onConfirm(e,user._id)}}
                                                                    body="Are you sure you want to delete this user?"
                                                                    confirmText="Confirm Delete"
                                                                    title="Delete">
                                                                    <button>Delete</button>
                                                                </Confirm>
                                                        }
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                        </Fragment>
                }
            </Container>
        );

    }
}
